import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Login from '@/views/PublicLogin.vue';
import PublicClassroom from '@/views/PublicClassroom.vue';
import Roles from '@/services/Roles';
import Class from '@/views/TeacherClass.vue';
import TeacherModules from '@/views/TeacherModules.vue';
import Admin from '@/views/Admin.vue';
import AdminTeacherDashboard from '@/views/AdminTeacherDashboard.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  // Public pages
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'TeacherModules' },
  },
  {
    path: '/leerkracht',
    redirect: { name: 'TeacherModules' },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      layout: 'clean',
    },
  },
  {
    path: '/klas/:uuid',
    name: 'Classroom',
    component: PublicClassroom,
  },
  // Teacher pages
  {
    path: '/leerkracht/modules',
    name: 'TeacherModules',
    component: TeacherModules,
    meta: {
      auth: true,
    },
  },
  {
    path: '/leerkracht/klassen',
    name: 'TeacherClasses',
    component: Class,
    meta: {
      auth: true,
    },
  },
  {
    path: '/leerkracht/klassen/:id',
    name: 'TeacherClass',
    component: Class,
    meta: {
      auth: true,
    },
  },
  // Admin pages
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      auth: true,
      admin: true,
    },
  },
  {
    path: '/admin/teacher/:id/dashboard',
    name: 'AdminTeacherDashboard',
    component: AdminTeacherDashboard,
    meta: {
      auth: true,
      admin: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAdmin = to.matched.some(record => record.meta.admin);
  const requiresAuth = requiresAdmin || to.matched.some(record => record.meta.auth);

  // this route requires auth, check if logged in
  // if not, redirect to login page.
  let needsRedirect = false;
  if (requiresAdmin) {
    const isAdmin = await Roles.isAdmin();
    needsRedirect = !isAdmin;
  } else if (requiresAuth) {
    const isTeacher = await Roles.isTeacher();
    needsRedirect = !isTeacher;
  }

  if (needsRedirect) {
    return next({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }
  return next();
});

export default router;
